import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@material-ui/core';
import { FormControlLabel, Checkbox, Grid } from '@material-ui/core';

class Note extends Component {
    state = {
        note_id: 0,
        note_mode: '',
        is_loaded: false,
        table_name: '',
        table_id: 0,
    }
    
    constructor(props) {
        super(props);
        this.state.note_id    = this.props.note_id    || 0;
        this.state.table_name = this.props.table_name || '';
        this.state.table_id   = this.props.table_id   || 0;
    }
    
    onEnter = () => {
        const { clearNote, getNote, setNoteLoaded } = this.props;
        
        this.setState({
            ...this.state,
            note_id: this.props.note_id
        });

        clearNote();
        if (this.props.note_id !== 0) {
            getNote(this.props.note_id);
        } else {
            setNoteLoaded(this.state.table_name, this.state.table_id);
        }
    }

    handleChange = (field_name) => (event) => {
        const { note, updateNote } = this.props;
        let value = event.target.value;

        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        updateNote(update_data);
    }

    handleSubmit = () => {
        const { saveNote, note } = this.props;

        saveNote(this.state.note_id, note, this.props.table_name_view, this.props.table_id_view);
        this.props.onClose();
    }

    handleClose = () => {
        this.props.onClose();
    }
    
    getContent = (note) => {
        if (!note.is_loaded) {
            return (<React.Fragment>Loading...</React.Fragment>);
        } else {
            return (
                <TextField
                    label="Description"
                    value={note.header.Description}
                    onChange={this.handleChange('Description')}
                    variant="outlined"
                    multiline={true}
                    fullWidth={true}
                    rows={3}
                />
            );
        }
    }

    render() {
        const { open, note } = this.props;
        const content = this.getContent(note);
        
        return (
            <Dialog
                aria-labelledby="note-creation"
                open={open}
                onEnter={this.onEnter}
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle id="note-creation">
                    Create Note
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={16}>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={Boolean(note.header.IsHTML)}
                                        onChange={this.handleChange('IsHTML')}
                                    />
                                }
                                label="Is HTML?"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            {content}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={this.handleSubmit} color="primary">
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        clearNote:       Actions.clearNote,
        getNote:         Actions.getNote,
        saveNote:        Actions.saveNote,
        updateNote:      Actions.updateNote,
        setNoteLoaded:   Actions.setNoteLoaded,
    }, dispatch);
}

function mapStateToProps({ note }) {
    return {
        note:            note.note.note,
        table_name_view: note.note.table_name_view,
        table_id_view:   note.note.table_id_view,
    }
}

export default withStyles(null, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Note)));




// WEBPACK FOOTER //
// src/main/components/note/Note.js